var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconConfig = function SvgIconConfig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#IconConfig_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "IconConfig_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.666 14a4.667 4.667 0 1 1-9.333 0 4.667 4.667 0 0 1 9.333 0zm-2.333 0a2.333 2.333 0 1 1-4.667 0 2.333 2.333 0 0 1 4.667 0z",
    fill: "#606060"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m2.834 10.006 2.124-3.678A1.167 1.167 0 0 1 6.322 5.8l2.143.682a9.303 9.303 0 0 1 1.79-1.033l.481-2.198a1.167 1.167 0 0 1 1.14-.917h4.247c.548 0 1.023.382 1.14.917l.48 2.198a9.315 9.315 0 0 1 1.79 1.033l2.144-.682a1.167 1.167 0 0 1 1.364.528l2.124 3.678c.274.475.18 1.077-.225 1.446l-1.662 1.515a9.287 9.287 0 0 1 0 2.067l1.662 1.515c.405.37.499.971.225 1.446l-2.124 3.678a1.167 1.167 0 0 1-1.364.528l-2.143-.682a9.32 9.32 0 0 1-1.79 1.034l-.481 2.197a1.167 1.167 0 0 1-1.14.917h-4.247a1.167 1.167 0 0 1-1.14-.917l-.48-2.197a9.305 9.305 0 0 1-1.791-1.034l-2.143.682a1.167 1.167 0 0 1-1.364-.528l-2.124-3.678a1.167 1.167 0 0 1 .225-1.446l1.662-1.514a9.302 9.302 0 0 1 0-2.068L3.06 11.452a1.167 1.167 0 0 1-.225-1.446zm12.35-5.339.534 2.441 1.088.478c.247.107.486.23.716.364l.004.002c.215.125.424.262.626.41l.957.704 2.381-.758 1.184 2.052-1.846 1.683.13 1.181c.03.258.043.516.043.774v.004c0 .258-.014.517-.042.775l-.131 1.182 1.846 1.683-1.184 2.051-2.38-.758-.958.704c-.204.15-.416.288-.634.415l-.003.002a6.968 6.968 0 0 1-.709.36l-1.088.477-.534 2.441h-2.369l-.534-2.441-1.088-.477a6.75 6.75 0 0 1-.669-.337l-.003-.002a6.95 6.95 0 0 1-.674-.438l-.957-.704-2.381.758-1.185-2.051 1.847-1.683-.13-1.182a6.964 6.964 0 0 1-.043-.774v-.005c0-.257.014-.516.042-.774l.131-1.181-1.847-1.683L6.51 8.308l2.38.758.958-.704c.214-.157.437-.302.666-.433l.004-.002a6.68 6.68 0 0 1 .676-.341l1.088-.478.534-2.44h2.369z",
    fill: "#606060"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#IconConfig_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#606060",
    d: "M-2-2h32v32H-2z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "IconConfig_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
};
export default SvgIconConfig;